// src/utils/message.js
import { ElMessage } from 'element-plus'
import type { MessageParams } from 'element-plus'

// 定义消息类型
type MessageType = 'success' | 'warning' | 'info' | 'error'

// 定义消息函数类型
interface MessageFunction {
  (message: string, type?: MessageType, options?: MessageParams): void
  success(message: string, options?: MessageParams): void
  warning(message: string, options?: MessageParams): void
  info(message: string, options?: MessageParams): void
  error(message: string, options?: MessageParams): void
  closeAll(): void
}

// 默认配置
const defaultOptions: MessageParams = {
  duration: 3000,
  showClose: true,
  center: false,
  offset: 20,
  customClass: '',
  grouping: false,
  dangerouslyUseHTMLString: false,
}

/**
 * 封装的消息提示方法
 */
const messageFunction = (
  message: string,
  type: MessageType = 'info',
  options: MessageParams = {},
) => {
  ElMessage({
    message,
    type,
    ...defaultOptions,
    ...options,
  })
}

// 创建并导出消息函数
export const message: MessageFunction = Object.assign(messageFunction, {
  success: (message: string, options = {}) => messageFunction(message, 'success', options),
  warning: (message: string, options = {}) => messageFunction(message, 'warning', options),
  info: (message: string, options = {}) => messageFunction(message, 'info', options),
  error: (message: string, options = {}) => messageFunction(message, 'error', options),
  closeAll: ElMessage.closeAll,
})
